// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"c469bbc7","496":"8d8889c6","647":"56b82a7a"}[chunkId] + ".chunk.js";
};